import { z } from "zod";
import { CATEGORIES } from "../constants/categories";

export const createBusinessSchema = z.object({
  displayName: z.string().min(1).max(100),
  category: z.enum(CATEGORIES),
  phone: z.string().max(20).optional(),
  bio: z.string().max(500).optional(),
  address: z.string().max(200).optional(),
  city: z.string().max(100).optional(),
  state: z.string().max(50).optional(),
  zip: z.string().max(20).optional(),
  latitude: z.number().min(-90).max(90).optional(),
  longitude: z.number().min(-180).max(180).optional(),
  timezone: z.string().default("America/New_York"),
});

export const updateBusinessSchema = createBusinessSchema.partial().extend({
  avatarUrl: z.url().optional().nullable(),
  coverUrl: z.url().optional().nullable(),
  leadTimeMinutes: z.number().int().min(0).max(10080).optional(), // up to 7 days
  bookingWindowDays: z.number().int().min(1).max(365).optional(),
  cancellationNoticeHours: z.number().int().min(0).max(168).optional(), // up to 7 days
});

const businessHourSchema = z.object({
  dayOfWeek: z.number().int().min(0).max(6),
  startTime: z.string().regex(/^\d{2}:\d{2}$/),
  endTime: z.string().regex(/^\d{2}:\d{2}$/),
  isOpen: z.boolean(),
});

export const updateBusinessHoursSchema = z.object({
  hours: z.array(businessHourSchema).length(7),
});

export const createOverrideSchema = z.object({
  date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
  isBlocked: z.boolean(),
  startTime: z.string().regex(/^\d{2}:\d{2}$/).optional(),
  endTime: z.string().regex(/^\d{2}:\d{2}$/).optional(),
});

export type CreateBusinessInput = z.infer<typeof createBusinessSchema>;
export type UpdateBusinessInput = z.infer<typeof updateBusinessSchema>;
export type UpdateBusinessHoursInput = z.infer<typeof updateBusinessHoursSchema>;
export type CreateOverrideInput = z.infer<typeof createOverrideSchema>;
